import { useEffect, useContext } from 'react';
import { calculatePerformanceScore } from '@smart-tv/utils/deviceProfiler';
import { TvContext } from '@smart-tv/contexts';

/**
 * Hook to set the performance score every 15 minutes.
 * It invokes the calculatePerformanceScore function from deviceProfiler.
 * If tizenVersion is available, it supplies it as an argument.
 */
const usePerformance = () => {
  const { platformVersion } = useContext(TvContext);
  const tizenVersion = window.tizen ? platformVersion : undefined;

  useEffect(() => {
    const setPerformanceScore = () => {
      if (tizenVersion) {
        calculatePerformanceScore(tizenVersion);
      } else {
        calculatePerformanceScore();
      }
    };

    setPerformanceScore();
    const intervalId = setInterval(setPerformanceScore, 15 * 60 * 1000); // 15 minutes

    return () => clearInterval(intervalId);
  }, [tizenVersion]);
};

export default usePerformance;
